import styled from 'styled-components';
import { useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { CollapsibleContentArrow, CollapsibleContent } from 'ui/collapsibleContent';
import { ParentRow, Row, CollapseBtn } from './CollapsibleMetricRow.styled';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
`;

const InlineFlex = styled.div`
  align-items: center;
  display: inline-flex;
`;

type RowType = {
  label: string;
  value: number;
};

type CollapsibleMetricRowProps = {
  label: string;
  value: number;
  rows: RowType[];
  tooltip?: string;
  last?: boolean;
};

export const CollapsibleMetricRow = ({
  last = false,
  label,
  tooltip,
  value,
  rows,
}: CollapsibleMetricRowProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const hasRows = rows.length > 0;
  return (
    <div data-expands={hasRows.toString()}>
      <ParentRow>
        <InlineFlex>
          {hasRows && (
            <CollapseBtn
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
              variant={BUTTON_VARIANTS.GHOST}
              size={BUTTON_SIZES.SMALL}
            >
              <CollapsibleContentArrow isCollapsed={isCollapsed} height={16} width={16} />
            </CollapseBtn>
          )}
          <Wrapper>
            <Tooltip isEnabled={!!tooltip} isUnderlined tooltipContent={tooltip}>
              <span>{label}</span>
            </Tooltip>
          </Wrapper>
        </InlineFlex>
        <span>{value.toLocaleString()}</span>
      </ParentRow>
      {hasRows && (
        <CollapsibleContent isCollapsed={isCollapsed}>
          {rows.map((row) => (
            <Row key={row.label} last={last}>
              <span>{row.label}</span>
              <span>{row.value.toLocaleString()}</span>
            </Row>
          ))}
        </CollapsibleContent>
      )}
    </div>
  );
};
